import React, {Fragment} from 'react';
import {PageTemplate, PageSEO} from '../molecules';
import {
  PageHeader,
  HeroSection,
  HeroTransitionSection,
  HowItWorksSection,
  PressTransitionSection,
  KnowSection,
  AwairScoreSection,
  TrackSection,
  ConquerSection,
  IntegrationsSection,
  TestimonialsSection,
  BuySection
} from '../organisms';
import ogImage from 'assets/images/seo/og-awair.jpg';

const AwairPage = () => {
  return (
    <Fragment>
      <PageSEO
        ogTitle={`アウェア公式サイト : AWAIR Japan`}
        ogDescription='いつも吸っている空気に何が含まれているか、知っていますか？Awairは空気中の有害物質を感知し、あなたの室内環境をより健康的で安全にするためのスマート空気モニターです。'
        ogImage={ogImage}
      />
      <PageTemplate
        pageHeader={<PageHeader />}
      >
        <HeroSection />
        <HeroTransitionSection />
        <HowItWorksSection />
        <PressTransitionSection />
        <KnowSection />
        <AwairScoreSection />
        <TrackSection />
        <ConquerSection />
        <IntegrationsSection />
        <TestimonialsSection />
        <BuySection />
      </PageTemplate>
    </Fragment>
  );
};

export default AwairPage;


// WEBPACK FOOTER //
// ./src/app/components/pages/AwairPage.js